import type { AccountTransaction } from '@viilu-web/shared/types/account-transactions'
import type { IntlShape } from 'react-intl'

export const accountTransactionsHeaders: Array<{
	title: (intl: IntlShape) => string
	key: keyof AccountTransaction
	type: 'string' | 'currency' | 'date' | 'status'
	sortable?: boolean
}> = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Viitenumero',
				description: 'Table header for reference number',
			}),
		key: 'referenceNumber',
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Saajan tili',
				description: 'Table header for creditor account',
			}),
		key: 'creditorAccount',
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Saajan nimi',
				description: 'Table header for creditor name',
			}),
		key: 'creditorName',
		type: 'string',
		sortable: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Summa',
				description: 'Table header for transaction amount',
			}),
		key: 'amount',
		type: 'currency',
		sortable: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tila',
				description: 'Table header for transaction status',
			}),
		key: 'status',
		type: 'status',
		sortable: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kirjauspäivä',
				description: 'Table header for booking date',
			}),
		key: 'bookingDate',
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Arvopäivä',
				description: 'Table header for value date',
			}),
		key: 'valueDate',
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tapahtumapäivä',
				description: 'Table header for transaction date',
			}),
		key: 'transactionDate',
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Viesti',
				description:
					'Table header for remittance message or additional information about the transaction.',
			}),
		key: 'remittanceMessage',
		type: 'string',
	},
]
